/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  ASSET_LIST_REQUEST,
  SAVE_ASSET,
  DELETE_ASSET,
  LOOKUP_ASSET,
  LOOKUP_PARCEL,
  HAS_ASSET,
  RESET_ASSET_LIST,
  SAVE_ASSET_NOT_FOUND_LOG,
  BULK_ADD_ASSET,
  DOWNLOAD_BULK_ADD_CSV,
  DOWNLOAD_ASSETS_BULK_ADD_CSV,
  BULK_ADD_CLIENT,
  ADD_ASSET_AND_FINANCIALS,
  RESET_ADD_ASSET,
  ADD_ENTITY,
  GET_ENTITIES,
} from "./assetActionTypes";

import {
  SET_ASSET_SLUG,
  GET_ASSET_BASIC_INFO,
  UPDATE_ASSET_BASIC_INFO,
  GET_ASSET_INVESTMENT_INFO,
  UPDATE_ASSET_INVESTMENT_INFO,
  GET_ASSET_EXPENSES,
  GET_ASSET_INCOMES,
  GET_ASSET_VALUATION,
  GET_ASSET_CASHFLOW,
  GET_ASSET_MONTHWISE_INCOMES,
  GET_ASSET_MONTHWISE_EXPENSES,
  GET_MONTHLY_OVERALL_CASHFLOW,
  GET_DASHBOARD_STATS,
  GET_ASSET_STATS,
  GET_YEARLY_GRAPH,
  GET_MONTHLY_GRAPH,
  GET_CASHFLOW_GRAPH,
  UPDATE_INCOME_GOAL,
  GET_ASSET_CHECKLIST,
  ADD_ASSET_MEDIAS,
  GET_ASSET_MEDIAS,
  DELETE_ASSET_MEDIA,
  RESET_BASIC_INFO,
  RESET_CASHFLOW_GRAPH,
  RESET_INVESTMENT_INFO,
  RESET_HAS_ASSET,
  SHOW_MISSING_IMPORT,
  GET_OVERALL_CASHFLOW,
  GET_CONTACT_ASSETS,
  ADD_CONTACT_ASSETS,
  ADD_ASSETS_DOCUMENT,
  BULK_ADD_CLIENT_ASSETS,
} from "../actionTypes";

export const asset_list = (dispatch) => {
  dispatch({
    type: ASSET_LIST_REQUEST,
  });
};
export const saveAsset = (assetData, dispatch) => {
  dispatch({
    type: SAVE_ASSET,
    payload: assetData,
  });
};

export const asset_detail = (asset_id, dispatch) => {
  dispatch({
    type: ASSET_LIST_REQUEST,
    payload: asset_id,
  });
};

export const deleteAsset = (payload, dispatch) => {
  dispatch({
    type: DELETE_ASSET,
    payload: payload,
  });
};

export const setAssetSlug = (slug, dispatch) => {
  dispatch({
    type: SET_ASSET_SLUG,
    payload: slug,
  });
};

export const getBasicInfo = (contactSlug, slug, dispatch) => {
  dispatch({
    type: GET_ASSET_BASIC_INFO,
    payload: { contactSlug, slug },
  });
};
export const updateBasicInfo = (data, dispatch) => {
  dispatch({
    type: UPDATE_ASSET_BASIC_INFO,
    payload: data,
  });
};
export const getInvestmentInfo = (slug, dispatch) => {
  dispatch({
    type: GET_ASSET_INVESTMENT_INFO,
    payload: slug,
  });
};

export const updateInvestmentInfo = (data, dispatch) => {
  dispatch({
    type: UPDATE_ASSET_INVESTMENT_INFO,
    payload: data,
  });
};

export const lookupAsset = (address, dispatch) => {
  dispatch({
    type: LOOKUP_ASSET,
    payload: address,
  });
};

export const bulkAddAsset = (data, dispatch) => {
  dispatch({
    type: BULK_ADD_ASSET,
    payload: data,
  });
};

export const bulkAddClient = (data, dispatch) => {
  dispatch({
    type: BULK_ADD_CLIENT,
    payload: data,
  });
};

export const downloadBulkAddCSV = (data, dispatch) => {
  dispatch({
    type: DOWNLOAD_BULK_ADD_CSV,
    payload: data,
  });
};

export const downloadAssetsBulkAddCSV = (data, dispatch) => {
  dispatch({
    type: DOWNLOAD_ASSETS_BULK_ADD_CSV,
    payload: data,
  });
};

export const getAssetExpenses = (data, dispatch) => {
  dispatch({
    type: GET_ASSET_EXPENSES,
    payload: data,
  });
};

export const getAssetIncomes = (data, dispatch) => {
  dispatch({
    type: GET_ASSET_INCOMES,
    payload: data,
  });
};

export const getAssetValuation = (data, dispatch) => {
  dispatch({
    type: GET_ASSET_VALUATION,
    payload: data,
  });
};

export const getAssetCashflow = (data, dispatch) => {
  dispatch({
    type: GET_ASSET_CASHFLOW,
    payload: data,
  });
};

export const getMonthWiseIncomes = (data, dispatch) => {
  dispatch({
    type: GET_ASSET_MONTHWISE_INCOMES,
    payload: data,
  });
};

export const getMonthWiseExpenses = (data, dispatch) => {
  dispatch({
    type: GET_ASSET_MONTHWISE_EXPENSES,
    payload: data,
  });
};

export const hasAsset = (data, dispatch) => {
  dispatch({
    type: HAS_ASSET,
    payload: data,
  });
};

export const resetAssetList = (dispatch) => {
  dispatch({
    type: RESET_ASSET_LIST,
  });
};

export const getMonthlyOverallCashflow = (dispatch) => {
  dispatch({
    type: GET_MONTHLY_OVERALL_CASHFLOW,
  });
};

export const getDashboardStats = (dispatch) => {
  dispatch({
    type: GET_DASHBOARD_STATS,
  });
};
export const getAssetStats = (data, dispatch) => {
  dispatch({
    type: GET_ASSET_STATS,
    payload: data,
  });
};

export const saveAssetNotFoundLog = (address, dispatch) => {
  dispatch({
    type: SAVE_ASSET_NOT_FOUND_LOG,
    payload: address,
  });
};

export const getYearlyGraph = (slug, dispatch) => {
  dispatch({
    type: GET_YEARLY_GRAPH,
    payload: slug,
  });
};

export const getMonthlyGraph = (slug, dispatch) => {
  dispatch({
    type: GET_MONTHLY_GRAPH,
    payload: slug,
  });
};

export const getCashFlowGraph = (data, dispatch) => {
  dispatch({
    type: GET_CASHFLOW_GRAPH,
    payload: data,
  });
};

export const updateIncomeGoal = (slug, dispatch) => {
  dispatch({
    type: UPDATE_INCOME_GOAL,
    payload: slug,
  });
};

export const getAssetChecklist = (slug, dispatch) => {
  dispatch({
    type: GET_ASSET_CHECKLIST,
    payload: slug,
  });
};

export const addAssetMedias = (data, dispatch) => {
  dispatch({
    type: ADD_ASSET_MEDIAS,
    payload: data,
  });
};

export const getAssetMedias = (slug, dispatch) => {
  dispatch({
    type: GET_ASSET_MEDIAS,
    payload: slug,
  });
};

export const deleteAssetMedia = (data, dispatch) => {
  dispatch({
    type: DELETE_ASSET_MEDIA,
    payload: data,
  });
};

export const getOverallCashflow = (data, dispatch) => {
  dispatch({
    type: GET_OVERALL_CASHFLOW,
    payload: data,
  });
};

export const cleanup = (dispatch) => {
  dispatch({
    type: RESET_HAS_ASSET,
  });

  dispatch({
    type: RESET_INVESTMENT_INFO,
  });

  dispatch({
    type: RESET_BASIC_INFO,
  });

  dispatch({
    type: SHOW_MISSING_IMPORT,
  });

  dispatch({
    type: RESET_CASHFLOW_GRAPH,
  });
};

export const hideMissingImport = (dispatch) => {
  dispatch({
    type: "HIDE_MISSING_IMPORT",
  });
};

export const getContactAssets = (dispatch, page, slug) => {
  dispatch({
    type: GET_CONTACT_ASSETS,
    payload: {
      slug,
      page,
    },
  });
};

export const addContactAssets = (dispatch, data, slug) => {
  dispatch({
    type: ADD_CONTACT_ASSETS,
    payload: {
      data,
      slug,
    },
  });
};

export const addAssetsDocument = (dispatch, files) => {
  dispatch({
    type: ADD_ASSETS_DOCUMENT,
    payload: files,
  });
};

export const bulkAddClientAssets = (dispatch, data) => {
  dispatch({
    type: BULK_ADD_CLIENT_ASSETS,
    payload: data,
  });
};

export const addAssetAndFinancials = (assetData, dispatch) => {
  dispatch({
    type: ADD_ASSET_AND_FINANCIALS,
    payload: assetData,
  });
};

export const lookupParcel = (parcelID, dispatch) => {
  dispatch({
    type: LOOKUP_PARCEL,
    payload: parcelID,
  });
};

export const resetAddAsset = (dispatch) => {
  dispatch({
    type: RESET_ADD_ASSET,
  });
};

export const addEntity = (data, dispatch) => {
  dispatch({
    type: ADD_ENTITY,
    payload: data,
  });
};

export const getEntities = (dispatch) => {
  dispatch({
    type: GET_ENTITIES,
  });
};
